// extracted by mini-css-extract-plugin
export default {"comfirmModal":"TimelineTripList_comfirmModal__nQ1KS"};